module.exports = __webpack_public_path__ + "img/contact.90b41ada.png";